import apiClient from '../axios';

export const leaveService = {
  // /**
  //  * Fetch all leave policies
  //  * @returns {Promise<Array>}
  //  */
  // getAllPolicies: async () => {
  //   const { data } = await apiClient.get('/leave-policies');
  //   return data;
  // },

  // /**
  //  * Create a new leave policy
  //  * @param {Object} policyData 
  //  * @returns {Promise<Object>}
  //  */
  // createPolicy: async (policyData) => {
  //   const { data } = await apiClient.post('/leave-policies', policyData);
  //   return data;
  // },

  /**
   * Fetch Leave Types for dropdowns
   * @returns {Promise<Array>}
   */
getLeaveTypes: async () => {
    const  response  = await apiClient.get('/leave-types');
    console.log(response)
    return response || [];
  },

  // POST /leave-types
  createLeaveType: async (data) => {
    const response = await apiClient.post('/leave-types', data);
    return response.data;
  },

  // PATCH /leave-types/:id
  updateLeaveType: async (id, data) => {
    const response = await apiClient.patch(`/leave-types/${id}`, data);
    return response.data;
  },

  // DELETE /leave-types/:id
  deleteLeaveType: async (id) => {
    const response = await apiClient.delete(`/leave-types/${id}`);
    return response.data;
  },

getAllEmployeeBalance: async (queryParams) => {
  const response = await apiClient.get(`/leave/employees/balances`, {
    params: queryParams,
  });
  return response;
 },

 getEmployeeLeaveRequests: async (employeeId, leaveTypeId = "") => {
    const params = leaveTypeId ? { leaveTypeId } : {};
    const response = await apiClient.get(`/leave/${employeeId}`, { params });

    return response;
  },

  // PATCH /leave/:requestId/approval
  approveLeave: async (requestId) => {
    const response = await apiClient.patch(`/leave/${requestId}/approval`, {});
    return response.data || response;
  },
    cancelLeave: async (requestId) => {
    const response = await apiClient.patch(`/leave/${requestId}/cancel`, {});
    return response.data || response;
  },
    rejectLeave: async (requestId) => {
    const response = await apiClient.patch(`/leave/${requestId}/reject`, {});
    return response.data || response;
  },

  // POST /leave-types
  createLeaveRequest: async (data) => {
    const response = await apiClient.post('/leave/request', data);
    return response.data;
  },
// In your leaveService.js (or frontend API file):
// In your leaveService.js file:
getLeaveBalanceEmployee: async (employeeId, year, leaveTypeId) => {
  const response = await apiClient.get(`/leave/my-balances/${employeeId}`, {
    params: {
      year,
      ...(leaveTypeId && { leaveTypeId }),
    },
  });
  return response;
},
}